import FilterChipMixin from './mixin.js';

const number_filter_chip_comp = {
  mixins: [FilterChipMixin],

  computed: {
    text_value: function() {
      var value;

      value = this.filter.value;
      if (value.lft && value.rgt) {
        return `${value.lft} ~ ${value.rgt}`;
      } else {
        if (value.lft) {
          return `大于等于${value.lft}`;
        } else if (value.rgt) {
          return `小于等于${value.rgt}`;
        } else {
          return '';
        }
      }
    }
  }
};

export {
  number_filter_chip_comp as IntegerFilterChip,
  number_filter_chip_comp as RatingFilterChip
};
